"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileTableContext = void 0;
const react_1 = require("react");
exports.FileTableContext = react_1.createContext({});
//# sourceMappingURL=file-table-context.js.map